import React, { useState, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { MdLocalPhone } from "react-icons/md";
import { FiMail } from "react-icons/fi";
import { Formik } from "formik";
import * as Yup from "yup";

import OutlinedButton from "components/layout/form/outlinedButton";
import RadioField from "components/layout/form/radioField";
import QuestionPool from "./QuestionPool";
import ValidationContact from "./ValidationContact";

import { useMFAContext } from "hooks/useMFA";
/*Removendo ou comentando useAuth, pois os contatos virão do useMFAContext
import { useAuth } from "hooks/authHook";*/


import { sendToken } from "../services";

import { HeaderContainer } from "../styles";
import {
  Container,
  ContainerButtons,
  FormContainer,
  RadioContent,
  Error,
  OpenModalQuestionsWrap,
} from "./styles";

const TypeToken = ({ setStep, userInfo, setUserInfo, setContactId }) => {
  const [loading, setLoading] = useState();
  const [openModalQuestions, setOpenModalQuestions] = useState(false);
  const [openModalNewContact, setOpenModalNewContact] = useState(false);
  const [tokenQuestions, setTokenQuetions] = useState("");

  const {
    attempts,
    setAttempts,
    setCredentials,
    MFAContacts,
    clearMFAContacts,
  } = useMFAContext();

  const history = useHistory();

  const { document, userId } = userInfo;

  const contactsAuth = useMemo(() => {
    if (MFAContacts?.length === 0) return [];

    const contactsPhone = MFAContacts?.filter(
      (contact) =>
        contact.contactType === "PHONE" && contact.isContactValidated === true
    );

    if (attempts < 3 && contactsPhone?.length > 0) {
      return contactsPhone;
    }

    return MFAContacts?.filter(
      (contact) => contact.isContactValidated === true
    );
  }, [userInfo, attempts, MFAContacts]);

  const handleSubmit = useCallback(
    async (contactId) => {
      if (!loading) {
        setLoading(true);
        const contact = MFAContacts?.find((c) => c.contactId === contactId);
        const success = await sendToken(contact, userInfo?.userId);
        if (success) {
          setStep(2);
          setUserInfo({ ...userInfo, validationContactId: contact?.contactId });
        }
        setLoading(false);
      }
    },
    [loading, userInfo, setStep, setUserInfo, MFAContacts]
  );

  const handleModal = (show, enableEditing) => {
    setOpenModalQuestions(show);

    if (enableEditing) {
      setOpenModalNewContact(true);
    }
  };

  const handleCloseModalNewContact = () => {
    setOpenModalNewContact(false);
  };

  const handleBack = () => {
    sessionStorage.removeItem("@UltragazEmpresarial:X-Mfa-Login");
    clearMFAContacts();
    setAttempts(1);
    setCredentials({ login: "", password: "", token: "" });
    history.push("/");
  };

  return (
    <Container>
      <HeaderContainer>
        <h1>Duplo fator de Autenticação</h1>
        <h2>Selecione um contato para receber o código</h2>
      </HeaderContainer>
      <Formik
        initialValues={{
          type: "",
        }}
        validationSchema={Yup.object().shape({
          type: Yup.string().required(
            "É necessário selecionar um tipo de token"
          ),
        })}
        onSubmit={() => {}}
      >
        {({ setFieldValue, errors, touched, values }) => (
          <FormContainer>
            {/* Array.prototype.filter() combinado com Array.prototype.findIndex() para garantir que apenas o
            primeiro contato com determinado valor de contact.contact */}
            {/* self.findIndex(...) === index garante que apenas a primeira
            ocorrência de um determinado contact.contact seja mantida. */}
            {contactsAuth
              ?.filter(
                (contact, index, self) =>
                  self.findIndex((c) => c.contact === contact.contact) === index
              )
              ?.map((contact) => (
              <RadioContent
                key={contact?.contactId}
                active={values.type === contact.contactId}
                onClick={() => {
                  setFieldValue("type", contact.contactId);
                  handleSubmit(contact.contactId);
                }}
                style={{
                  backgroundColor: values.type === contact.contactId ? "#007BFF" : "",
                  color: values.type === contact.contactId ? "#fff" : "",
                }}
              >
                <RadioField
                  id={contact?.contactId}
                  type="radio"
                  name="type"
                  value={contact?.contactId}
                >
                    <div>
                      {contact?.contactType === "PHONE" ? (
                        <MdLocalPhone />
                      ) : (
                        <FiMail />
                      )}
                      <span>
                        Via {contact?.contactType === "PHONE" ? "SMS" : "email"}
                      </span>
                    </div>
                    <span>{contact?.contact}</span>
                  </RadioField>
                </RadioContent>
              ))}
            {errors.type && touched.type && errors.type && (
              <Error>{errors.type}</Error>
            )}
            <OpenModalQuestionsWrap onClick={() => setOpenModalQuestions(true)}>
              Não reconheço nenhum desses contatos. Quero alterar os dados
              cadastrados.
            </OpenModalQuestionsWrap>
            <ContainerButtons>
              <OutlinedButton
                width="100%"
                LeadingIcon={() => <IoMdArrowBack size={20} />}
                onClick={handleBack}
              >
                Voltar
              </OutlinedButton>
            </ContainerButtons>
          </FormContainer>
        )}
      </Formik>
      {openModalQuestions && (
        <QuestionPool
          body={{ document, userId }}
          handleModal={handleModal}
          setLoading={setLoading}
          setTokenQuetions={setTokenQuetions}
        />
      )}
      {tokenQuestions && (
        <ValidationContact
          setContactId={setContactId}
          document={document}
          userId={userId}
          show={openModalNewContact}
          handleCloseModal={handleCloseModalNewContact}
          tokenQuestions={tokenQuestions}
          setStepSideBar={setStep}
        />
      )}
    </Container>
  );
};

export default TypeToken;
